import { RootState } from "@/store/store";
import { resourcesGridSliceSelector } from "@/store/resources-grid/selectors/resourcesGridSliceSelector";
import { ResourceType } from "@/services/cloudchipr.api";

export const resourcesMasterGridIdByResourceTypeSelector = (
  state: RootState,
  resourceType: ResourceType,
) => {
  const slice = resourcesGridSliceSelector(state);

  return Object.keys(slice?.grids ?? {}).find((masterGridId) => {
    const grid = slice?.grids?.[masterGridId];

    return grid?.resourceType === resourceType && grid.resourceDataPayload;
  });
};
